import styled from 'styled-components';
import { Box } from '../Box/Box.es.js';
import { spacing } from '../../utils/theme.es.js';

const Grid = styled(Box)`
    display: grid;
    grid-template-columns: repeat(auto-fill, ${({ columnWidth }) => columnWidth}px);
    gap: ${({ gutter = "md" }) => spacing(gutter)};
    > div,
    > a {
        margin: 0;
    }
`;
Grid.displayName = "Grid";

export { Grid };
//# sourceMappingURL=Grid.es.js.map
